import {ChangeDetectionStrategy, Component, effect, input, viewChild} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {GruppeModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {Navigasjon} from "web-ng2/tjenester/Navigasjon";
import {MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable, MatTableDataSource, MatTableModule} from "@angular/material/table";
import {ReactiveFormsModule} from "@angular/forms";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {Autentiseringsmetode, GruppeId} from "../../../../../felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {erNil} from "../../../../../felles-ng2/støttefunksjoner/nilsjekk";
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {GruppeLogoKomponent} from "../gruppe-logo/gruppe-logo";
import {MatTooltip} from "@angular/material/tooltip";
import {EnumOversettelser} from "felles-ng2/tjenester/i18n/EnumOversettelser";

const debug = initDebugger('GrupperListMalerKomponent');

@Component({
    selector: 'grupper-list-maler',
    templateUrl: 'grupper-list-maler.html',
    styleUrl: 'grupper-list-maler.scss',
    imports: [
        TranslateModule,
        MatTable,
        MatColumnDef,
        MatHeaderCell,
        MatCell,
        MatHeaderCellDef,
        MatCellDef,
        MatHeaderRow,
        MatRow,
        MatRowDef,
        MatHeaderRowDef,
        ReactiveFormsModule,
        MatSort,
        MatTableModule, MatSortModule, MatButton, MatIcon, GruppeLogoKomponent, MatTooltip
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GrupperListMalerKomponent /*implements AfterViewInit*/ {
    static ajsSelector = 'grupperListMaler';

    maler = input<GruppeModell[]>([]);
    malerDataSource: MatTableDataSource<GruppeModell> = new MatTableDataSource<GruppeModell>();
    malerSort = viewChild(MatSort);


    constructor(private navigasjon:Navigasjon, private enumOversettelser: EnumOversettelser) {

        effect(() => {
            this.malerDataSource.data = this.maler();
        });

        effect(() => {
            const sortInstance = this.malerSort();
            this.malerDataSource.sortingDataAccessor = (item: GruppeModell, property: string) => {
                switch (property) {
                    case 'beskrivelse':
                        return item.gruppemal?.beskrivelse;

                    case 'mal':
                        return item.gruppemal?.navn;

                    case 'innlogging':
                        return lavesteAutentiseringsmetode(item.tillatteAutentiseringsmetoder);

                  // For alle andre kolonner (som 'id'), bruk standard oppførsel
                    default:
                        return (item as any)[property];
                }
            };

            // 3. Koble til sort-instansen ETTER at sortingDataAccessor er definert
            if (sortInstance) {
                this.malerDataSource.sort = sortInstance;
            }
        });
    }

    gaaTilGruppe(gruppeId: GruppeId) {
        this.navigasjon.gåTilGruppe(gruppeId);
    }

    lavesteAutentiseringsmetodeTekst(gruppe: GruppeModell): string {
        let laveste = lavesteAutentiseringsmetode(gruppe.tillatteAutentiseringsmetoder);
        if (!erNil(laveste)) return this.autentiseringsmetodeTekst(laveste);
        return ''; // bør ikke skje
    }


    autentiseringsmetoder(gruppe: GruppeModell): string[] {
        if (erNil(gruppe)) return [];
        return gruppe.tillatteAutentiseringsmetoder.slice().sort().map(metode => this.autentiseringsmetodeTekst(metode));
    }

    private autentiseringsmetodeTekst(metode: Autentiseringsmetode): string {
        return this.enumOversettelser.oversettetAutentiseringsmetode(metode);
    }

}

export function lavesteAutentiseringsmetode(autentiseringsmetoder: Autentiseringsmetode[]): Autentiseringsmetode {
    let metoderSortert = [Autentiseringsmetode.passord, Autentiseringsmetode.smsOtp, Autentiseringsmetode.totpOtp, Autentiseringsmetode.criiptoOpenId];
    // må legge til erNil, siden Autentiseringsmetode.passord = 0, som blir tolket som false
    return metoderSortert.find((sortertMetode) => !erNil(autentiseringsmetoder.find(m => m === sortertMetode)))!;
}
